import React from 'react';
import * as Styled from './MCarouselControls.styles';
import { AIcon, AIconSize } from '../../atoms/AIcon/index';
import { MCarouselControlsProps, MCarouselControlsType } from './MCarouselControls.types';

export const MCarouselControls: React.FC<MCarouselControlsProps> = ({
  type = MCarouselControlsType.Dots,
  imageOverlay = false,
  arrows = true,
  iconSize = AIconSize.M,
  totalSlides = 5,
  currentSlide = 0,
  onNext,
  onPrev,
}) => {
  const renderDots = () => {
    if (totalSlides < 1) return null;
    const dotsArray = Array.from({ length: totalSlides }, (_, index) => index);
    return (
      <Styled.DotContainer className="d-flex justify-content-center align-items-center" $withOverlay={imageOverlay}>
        {dotsArray.map(index => (
          <Styled.Dot key={index} $active={index === currentSlide} data-testid="dots" />
        ))}
      </Styled.DotContainer>
    );
  };

  const renderBar = () => {
    if (totalSlides < 1) return null;
    const progressPercent = ((currentSlide + 1) / totalSlides) * 100;
    return (
      <Styled.BarContainer $withOverlay={imageOverlay}>
        <Styled.BarFill style={{ width: `${progressPercent}%` }} />
      </Styled.BarContainer>
    );
  };

  return (
    <Styled.Wrapper className="d-flex align-items-center">
      {arrows && (
        <Styled.ArrowButton type="button" className="d-flex align-items-center justify-content-center" onClick={onPrev}>
          <AIcon icon={'icon-arrow-left'} size={iconSize as AIconSize} aria-label="previous" />
        </Styled.ArrowButton>
      )}
      <Styled.ControlsArea className="d-flex align-items-center justify-content-center">
        {type === MCarouselControlsType.Dots && renderDots()}
        {type === MCarouselControlsType.Bar && renderBar()}
      </Styled.ControlsArea>
      {arrows && (
        <Styled.ArrowButton type="button" className="d-flex align-items-center justify-content-center" onClick={onNext}>
          <AIcon icon={'icon-arrow-right'} size={iconSize as AIconSize} aria-label="next" />
        </Styled.ArrowButton>
      )}
    </Styled.Wrapper>
  );
};
